/**
 * @file modules/my_cash_history_selector.js
 * @description Vanilla JS module for toggling between Cash back and Payouts
 *              history views on the My Cash page.
 */

import { dispatchTrack } from "../analytics/shop-analytics-track.js";

export function initHistorySelector() {
  const selector = document.querySelector(".my-cash-history-selector");
  if (!selector) return;

  selector.addEventListener("change", (event) => {
    const selectedView = event.target.value;
    const containers = document.querySelectorAll(".my-cash-history-container");

    containers.forEach((container) => {
      if (container.dataset.view === selectedView) {
        container.classList.add("my-cash-history-container--active");
      } else {
        container.classList.remove("my-cash-history-container--active");
      }
    });

    dispatchTrack(selector, "my_cash_history_filter_change", {
      source: "My Cash",
      filter: selectedView,
    });
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initHistorySelector);
} else {
  initHistorySelector();
}
